const GoogleIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" transform="translate(0 1)" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.54 12.2613C22.54 11.4459 22.4668 10.6618 22.3309 9.90906H11.5V14.3575H17.6891C17.4225 15.795 16.6123 17.0129 15.3943 17.8284V20.7138H19.1109C21.2855 18.7118 22.54 15.7636 22.54 12.2613Z"
      fill="#4285F4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4995 23.4998C14.6045 23.4998 17.2077 22.47 19.1104 20.7137L15.3938 17.8282C14.364 18.5182 13.0467 18.9259 11.4995 18.9259C8.50425 18.9259 5.96902 16.903 5.0647 14.1848H1.22266V17.1644C3.11493 20.9228 7.00402 23.4998 11.4995 23.4998Z"
      fill="#34A853"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.06523 14.1851C4.83523 13.4951 4.70455 12.7581 4.70455 12.0001C4.70455 11.2422 4.83523 10.5051 5.06523 9.81512V6.83557H1.22318C0.444318 8.38807 0 10.1444 0 12.0001C0 13.8558 0.444318 15.6122 1.22318 17.1647L5.06523 14.1851Z"
      fill="#FBBC05"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4995 5.07386C13.1879 5.07386 14.7038 5.65409 15.8956 6.79364L19.194 3.49523C17.2024 1.63955 14.5992 0.5 11.4995 0.5C7.00402 0.5 3.11493 3.07705 1.22266 6.83545L5.0647 9.815C5.96902 7.09682 8.50425 5.07386 11.4995 5.07386Z"
      fill="#EA4335"
    />
  </svg>
);
export default GoogleIcon;
